export default class extends Controller {
  connect() {
    App.Users.initForm(this.element)
  }
}



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/users/user-profile-form-controller.js